import ReactDOM from "react-dom";
import h from "h";
import RenewResults from "./RenewResults";
export default function initRenewResults(node, props) {
  ReactDOM.render(h(RenewResults, props), node);
}
